import { brandScope } from './scope'
import type { Session, Vcard } from '../types'

/**
 * Client-Spiegel der Server-Berechtigungen (Spec §2 / Dummy `can`). Der Client
 * erzwingt nichts sicherheitskritisch — er verbirgt/deaktiviert nur, was der
 * Server ohnehin per Guard ablehnt. Quelle der Rolle ist immer die Session (JWT).
 *
 * Das brand-admin-Scoping (admin sieht alles, brand-admin nur eigene Brand)
 * stammt aus dem zentralen `scope.ts` (Single-Source).
 */
export function can(s: Session) {
  const scope = brandScope(s)
  const self = {
    brandEdit: (bk: string) => scope.assertBrandAccess(bk),
    brandCreate: () => scope.isAdmin,
    // Domain-Verwaltung ist admin-only (brand-admin darf eigene Domains NICHT selbst verwalten).
    domainManage: () => scope.isAdmin,
    accountsView: () => scope.isAdmin || scope.isBrandAdmin,
    vcardView: (vc: Vcard) =>
      scope.assertBrandAccess(vc.brandKey) || (s.role === 'user' && s.vcardUrlKey === vc.urlKey),
    vcardEdit: (vc: Vcard) => self.vcardView(vc),
    vcardCreate: () => scope.isAdmin,
    vcardDelete: () => scope.isAdmin,
  }
  return self
}
